import { Typo3Page, Typo3SectionSpotSanityStory } from '@/types'
import { ContentBlocks } from '@/ui/components'
import {
  SectionAuthor,
  SectionCtaSingle,
  SectionHero,
  SectionText
} from '@/ui/Sections'
import { memo } from 'react'

interface Props {
  data: Typo3SectionSpotSanityStory
  pageData: Typo3Page
}

const Detail = ({ data, pageData }: Props) => (
  <>
    <SectionHero
      pageData={{
        ...pageData,
        appearance: { layout: 'page' }
      }}
      data={{
        appearance: {
          layout: 'default'
        },
        images: data?.content?.item?.images ?? [],
        title: data?.content?.item?.contentHeader?.title,
        hasText: data?.content?.item?.contentHeader?.text ? true : false,
        text: data?.content?.item?.contentHeader?.lead
      }}
    />
    <SectionText
      section={{
        appearance: {
          spaceBefore: 'none'
        }
      }}
      text={data?.content?.item?.contentHeader?.text}
    />
    <ContentBlocks blocks={data?.content?.item?.contentBlocks} />
    <SectionAuthor
      section={data}
      image={data?.content?.item?.images ?? []}
      author={data?.content?.item?.contentAuthor?.author ?? ''}
      text={data?.content?.item?.contentAuthor?.text ?? ''}
    />
    <SectionCtaSingle
      title={data?.content?.item?.directoryTeaser?.[0]?.title}
      body={data?.content?.item?.directoryTeaser?.[0]?.summary}
      button={{
        href: data?.content?.item?.directoryTeaser?.[0]?.uri?.href,
        label: data?.content?.item?.directoryTeaser?.[0]?.uri?.title
      }}
      chipContent={data?.content?.item?.directoryTeaser?.[0]?.category}
      image={data?.content?.item?.directoryTeaser?.[0]?.image?.[0]}
      variant="content"
    />
    {/* <DirectoryTeaser data={data} /> */}
  </>
)

export default memo(Detail)
